import { Pipe, PipeTransform } from '@angular/core';
import { IEventInfoResourcePhotoResponseBm } from '@outlook-addin/cue-http';

@Pipe({
  name: 'photosToFile',
  standalone: true,
})
export class PhotosToFilePipe implements PipeTransform {
  transform(photoList: IEventInfoResourcePhotoResponseBm[]): any[] {
    return photoList.map((x) => {
      return x.file;
    });
  }
}
